import { render, staticRenderFns } from "./TariffsCheck.vue?vue&type=template&id=3815b447&"
import script from "./TariffsCheck.vue?vue&type=script&lang=js&"
export * from "./TariffsCheck.vue?vue&type=script&lang=js&"
import style0 from "./TariffsCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports